<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <dialog-table-page ref="customerDetailTable" :pageData="customerPageData"></dialog-table-page>
    <dialog-table-page ref="tradeDetailTable" :pageData="tradePageData"></dialog-table-page>
    <div style="text-align:right;line-height:30px;margin-right:119px;">
      <p>{{$t('txmis.relationAnaly.monthTotal')}}：{{$t('txmis.relationAnaly.efficientRelation')}}<span>{{sub.invite_month_total}}</span>{{$t('txmis.relationAnaly.people')}}，{{$t('txmis.relationAnaly.trade')}}<span>{{sub.trade_month_total}}</span>手</p>
      <p>{{$t('txmis.relationAnaly.allTotal')}}：{{$t('txmis.relationAnaly.efficientRelation')}}<span>{{sub.invite_total}}</span>{{$t('txmis.relationAnaly.people')}}，{{$t('txmis.relationAnaly.trade')}}<span>{{sub.trade_total}}</span>手</p>
    </div>
  </div>
</template>
<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import dialogTablePage from '@/components/page/dialogTable.vue'
    import FORM from '@/components/page/form.vue'
    import URL from '@/views/newmis36/util/url'
    import download from "@/utils/download";
    import Qs from 'qs'
    import DateUtil from "@/utils/IM/tradeDataUtil";
    let symbolType = {"2": "外汇", "1": "贵金属", "5": "指数", "4": "商品", "-1": "不限产品","100": "非虚拟币", "7": "股票", "6": "货币"};
    //接口地址url的统一管理
    export default {
        name: 'relationAnaly',
        components: {
            tablePage,
            FORM,
            dialogTablePage,
        },
        methods: {
            bthClick(clickName, row) {
                if (clickName == "customerDetail") {
                    this.customerPageData.sync = true;
                    let data = {type:0,time:row.time,customerNumber:row.customerNumber};
                    this.$refs.customerDetailTable.defaultQueryData(data);
                }else if (clickName == "tradeDetail") {
                    this.tradePageData.sync = true;
                    let data = {type:1,time:row.time,customerNumber:row.customerNumber};
                    this.$refs.tradeDetailTable.defaultQueryData(data);
                }
            },
            /*获取统计数据*/
            getTotal(data){
              this.$axios.post(URL.relationAnaly.statistics, Qs.stringify(data || {})).then(res => {
                console.log(res);
                if (res.code == 0) this.sub = res.result;
              }).catch(res => {})
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    if(data.year && data.month) {
                        if (data.month.toString().length == 1) data.month = "0" + data.month;
                        data.time = data.year+data.month;
                    }
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                    this.getTotal(data);
                }else if(window.$t('txmis.bt.down') == clickName){
                  //隐藏关键字段
                  const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:false});
                  download.exportExcel(URL.relationAnaly.export,param,window.$t('txmis.relationAnaly.relationAnaly'));
                }
            },
        },
        data () {
            return {
                detailAmount: 0,
                queryData:{},
                sub:{},
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                    { title: window.$t('txmis.relationAnaly.year'), field: 'year'},
                    { title: window.$t('txmis.relationAnaly.month'), field: 'month'},
                    { title: window.$t('txmis.relationAnaly.customerNumber'), field: 'customerNumber'},
                    {click:window.$t('txmis.bt.search')},
                    {click:window.$t('txmis.bt.down')},
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.relationAnaly.list, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.relationAnaly.time'), field: 'time',render:(data,full)=>{
                          return  data.toString().slice(0, 4) + "." + data.toString().slice(4);
                          }},
                        { title: window.$t('txmis.relationAnaly.customerNumber'), field: 'customerNumber'},
                        { title: window.$t('txmis.relationAnaly.inviteTotal'), field: 'inviteTotal'},
                        { title: window.$t('txmis.relationAnaly.inviteMonthTotal'), field: 'inviteMonthTotal',h5Click: "customerDetail"},
                        { title: window.$t('txmis.relationAnaly.tradeTotal'), field: 'tradeTotal'},
                        { title: window.$t('txmis.relationAnaly.tradeMonthTotal'), field: 'tradeMonthTotal',h5Click: "tradeDetail"},
                    ]
                },
                customerPageData: {
                    title: window.$t('txmis.relationAnaly.customerDetail'),
                    sync:false,
                    isShow: false,
                    queryUrl: URL.relationAnaly.detail, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.relationAnaly.customerNumber'), field: 'customerNumber'},
                        {title: window.$t('txmis.relationAnaly.activeTime'), field: 'activeTime',render:(data,full)=>{
                          return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");}},
                        {title: window.$t('txmis.relationAnaly.ctime'), field: 'ctime',render:(data,full)=>{
                          return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");}}
                    ]
                },
                tradePageData: {
                    title: window.$t('txmis.relationAnaly.tradeDetail'),
                    sync:false,
                    isShow: false,
                    queryUrl: URL.relationAnaly.detail, //请求路径和参数
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.rebateComponents.customerNumber'), field: 'customerNumber'},
                        {title: window.$t('txmis.rebateComponents.symbolType'), field: 'symbolType', render: (data, full) => {
                                return symbolType[data] || "";
                            }},
                        {title: window.$t('txmis.rebateComponents.displayName'), field: 'displayName'},
                        {title: window.$t('txmis.rebateComponents.orderId'), field: 'orderId'},
                        {title: window.$t('txmis.rebateComponents.execVolume'), field: 'execVolume'},
                        {title: window.$t('txmis.rebateComponents.execTime'), field: 'execTime',render:(data,full)=>{
                          return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                        }}

                    ]
                }
            }
        }
    }
</script>

